<div *ngIf="offer">
  <div class="container" *ngIf="offer">
    <div class="section-top">
      <div class="column-left-top">
        <app-export-offer-detail-carousel [offer]="offer"></app-export-offer-detail-carousel>
      </div>

      <div class="column-right-top">
        <div>
          <div class="header-card">
            <div class="section-titles">

              <h2 class="title-product">
                {{offer.variety.species.name}} / {{offer.variety.name}}
              </h2>

                <span class="title-price" *ngIf="profile?.profileType === 'Importer'">
                  {{ offer.listPrice | currency: 'USD':'US$' }}
                  {{ offer.typeSale ? offer.typeSale : "" }}
                  <span class="subtitle-small">
                    {{'ExportOffer.ExportOfferDetail.PerBoxLabel' | translate}}
                  </span>
                </span>

            </div>
            <!--
              <div class="section-networks">
                <app-social-media-share [url]="urlRoute"></app-social-media-share>
              </div>
            -->
            <div class="section-suggested-price" *ngIf="suggestedPrice">
              <div class="section-row">
                {{'ExportOffer.ExportOfferDetail.SuggestedLabel' | translate}}
                <span class="icon-circle">$</span>
              </div>
              <div class="section-row-price">
                {{suggestedPrice | currency: 'USD':'US$' }}
                <span class="currency-small">
                  {{ typeSale ? typeSale : "" }}
                </span>
              </div>
            </div>
          </div>

          <div class="section-main-info">

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.CasePerPalletsText' | translate}}:</h5>
              <p class="data-main-info">
                {{offer.caseQuantityPerPallet }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.PaymentAgainstOffer' | translate}}:</h5>
              <p class="data-main-info">
                {{ offer.netKilos ? offer.paymentAgainstBL + ' %' : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'ExportOffer.ExportOfferDetail.FinalPaymentSubjectQC' | translate}}:</h5>
              <p class="data-main-info">
                {{ finalPaymentSubjectQC }} %
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'ExportOffer.ExportOfferDetail.InitialPalletsText' | translate}}:</h5>
              <p class="data-main-info">
                {{ offer.palletQuantity }}
              </p>
            </div>

            <!--
            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.SpeciesSizeText' | translate}}:</h5>
              <p class="data-main-info">
                <app-text-preview
                  [text]="offer.speciesSize ? offer.speciesSize : getAvailableLabel()"
                  [maxLength]="30">
                </app-text-preview>
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'ExportOffer.ExportOfferDetail.ShelfLife' | translate}}:</h5>
              <p class="data-main-info">
                {{ offer.shelfLife ? offer.shelfLife +  " " + translate.instant('MarketplacePage.WishList.ExportOfferModal.DayShelflifeText') : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.NetKilosText' | translate}}:</h5>
              <p class="data-main-info">
                {{ offer.netKilos ? offer.netKilos + ' Kg' : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.UnitPrice' | translate}}:</h5>
              <p class="data-main-info" *ngIf="offer.listPrice">
                {{ offer.listPrice | currency: 'USD':'US$' }}
                {{ offer.typeSale ? offer.typeSale : "" }}
              </p>
              <p class="data-main-info" *ngIf="!offer.listPrice">
                getNoAvailableLabel()
              </p>
            </div>

            -->

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.AvailablePalletsText' | translate}}:</h5>
              <p class="data-main-info">
                {{ offer.availablePallets }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.Packaging' | translate}}:</h5>
              <p class="data-main-info">
                {{ offer.netKilos ? getPackagingTypes(offer.packagingTypes) : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'ExportOffer.ExportOfferDetail.AvailableProductCertificates2' | translate}}:</h5>
              <p class="data-main-info" *ngIf="offer.certificates">{{ getCertificatesName(offer.certificates) }}</p>
              <span *ngIf="!offer.certificates">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
            </div>
          </div>

          <!--
          <div class="p-fluid formgrid grid align-items-start" *ngIf="profile?.profileType === 'Importer'"
            style="margin-top: 15px;">
            <div class="col-12" style="margin-bottom: 15px;">
              <h2 class="data-main-info" >{{'MarketplacePage.WishList.ExportOfferModal.PurchaseForm.Title' | translate}}</h2>
            </div>
              <div class="P-field col-12 md:col-4 lg:col-4">
                <form [formGroup]="purchaseForm">
                  <label for="palletsId">Pallets</label>
                  <p-inputNumber
                  #palletsId
                  formControlName="pallets"
                  [showButtons]="false" [min]="1"
                  [max]="maxSale" [size]="2"
                  buttonLayout="horizontal"
                  spinnerMode="horizontal" [step]="1"
                  decrementButtonIcon="pi pi-minus" (onBlur)="onInputSale($event)" (onInput)="onInputSale($event)"
                  [style]="{'padding-top':'.5em'}"
                  class="p-inputtext-sm input-product-detail-custom"></p-inputNumber>
                  <small *ngIf="!allowPurchase == true"
                  class="p-error">{{getPalletsErrorMessage('pallets')}}</small>
                  <small *ngIf="purchaseForm.controls['pallets'].invalid"
                  class="p-error">{{getPurchaseMessage('pallets')}}</small>
                </form>
              </div>
              <div class="field col-12 md:col-12 lg:col-4">
                <label>&nbsp;</label>
                <p-button
                label="{{'MarketplacePage.WishList.ExportOfferModal.PurchaseForm.PurchaseNowButton' | translate}}"
                (onClick)="createOrder()"
                [disabled]="!allowPurchase"
                [loading]="loading"></p-button>
              </div>
          </div>

            <form [formGroup]="negotiationFormGroup" *ngIf="profile?.profileType === 'Importer'"
              style="margin-top: 30px;">
              <div class="grid">
                <div class="col-12">
                  <h2 class="data-main-info">{{'MarketplacePage.WishList.ExportOfferModal.NegotiationFieldSetLegend' | translate}}</h2>
                </div>
                <div class="col-12">
                  <div class="p-fluid formgrid grid flex align-items-start">
                    <div class="field col-12 md:col-4 lg:col-4">
                      <label for="negociation-price">{{'MarketplacePage.WishList.ExportOfferModal.NegotiationPriceFieldLable' | translate}}</label>
                      <p-inputNumber inputId="negociation-price" formControlName="negociationPrice" [min]="0"
                        mode="currency" currency="USD" locale="en-US" placeholder="{{'MarketplacePage.WishList.ExportOfferModal.NegotiationPriceFieldPlaceholder' | translate}}"
                        class="p-inputtext-sm input-product-detail-custom"></p-inputNumber>
                      <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negociationPrice'].invalid"
                        class="p-error">{{getErrorMessage('negociationPrice')}}</small>
                    </div>
                    <div class="field col-12 md:col-4 lg:col-4">
                      <label for="negotiation-pallets">{{'MarketplacePage.WishList.ExportOfferModal.PalletsFieldLabel' | translate}}</label>
                      <p-inputNumber inputId="negotiation-pallets" formControlName="negociationPallets" [min]="1" (onBlur)="onInputNegotiation($event)"
                      (onInput)="onInputNegotiation($event)"
                        [max]="maxSale" class="p-inputtext-sm input-product-detail-custom"></p-inputNumber>
                      <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negociationPallets'].invalid"
                        class="p-error">{{getErrorMessage('negociationPallets')}}</small>
                        <p style="font-size: 11px;" *ngIf="!allowNegotiation"
                        class="p-error">{{getPalletsErrorMessage('negociationPrice')}}</p>
                    </div>
                    <div class="field col-12 md:col-4 lg:col-4">
                      <label for="negociation-incoterm">{{'MarketplacePage.WishList.ExportOfferModal.SellModeFieldLabel' | translate}}</label>
                      <p-dropdown inputId="negociation-incoterm" formControlName="negociationIncoterm"
                        (onChange)="onChangeIncoterm($event)" [options]="incotermsOptions" optionLabel="label" optionValue="value"
                        placeholder="{{'MarketplacePage.WishList.ExportOfferModal.SellModeFieldPlaceholder' | translate}}" appendTo="body" class="p-inputtext-sm input-product-detail-custom"></p-dropdown>
                        <p class="span-error">
                          <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negociationIncoterm'].invalid" class="p-error">{{getErrorMessage('negociationIncoterm')}}</small>
                        </p>
                    </div>
                    <div class="field col-12 md:col-4 lg:col-4 m-0">
                      <label for="negociation-paymentAgainstBL">
                        {{'UserPages.UserBargaining.OpenTab.BargainingDetail.MakeCounterOfferModal.PaymentAgainstBLLabel' | translate}} *
                        <i class="pi pi-info-circle" style="font-size: .7rem; color:#8C2B87"
                          pTooltip="{{ paymentBLTitle | translate }}"
                        ></i>
                      </label>
                      <p-dropdown id="negociation-paymentAgainstBL" formControlName="negotiationPaymentAgainstBL" [options]="paymentBLItems" optionLabel="label" optionValue="value" placeholder="{{'UserPages.UserBargaining.OpenTab.BargainingDetail.MakeCounterOfferModal.PaymentAgainstBLLabel' | translate}}" appendTo="body" class="input-product-detail-custom"></p-dropdown>
                      <p class="span-error">
                        <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negotiationPaymentAgainstBL'].invalid" class="p-error">{{getErrorMessage('negotiationPaymentAgainstBL')}}</small>
                      </p>
                      <p class="span-green">
                        <small *ngIf="showPaymentBLPercent">{{finalPaymentPercent}}% {{'UserPages.UserExportOffers.NewExportOffer.FinalPaymentSubjectQCReview' | translate}}</small>
                      </p>
                    </div>
                    <div class="field col-12 md:col-4 lg:col-4">
                      <label>&nbsp;</label>
                      <p-button
                      label="{{'MarketplacePage.WishList.ExportOfferModal.CreateNegotiationButton' | translate}}"
                      (onClick)="createNegotiation()"
                      [loading]="loading2"
                      [disabled]="profile?.profileType !== 'Importer'||!allowNegotiation"
                      [style]="{'background-color': '#8c2b87'}">
                    </p-button>
                      <label *ngIf="submitNegotiation && !negotiationFormGroup.valid">&nbsp;</label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          -->

        </div>
      </div>

    </div>


    <div class="section-bottom-pdt-3" *ngIf="profile?.profileType === 'Importer'">
      <div class="section-description">
        <h2 class="title-section">{{'ExportOffer.ExportOfferDetail.SpecieDescription.Title' | translate}}</h2>
        <div class="section-description-info">
          <div class="rowInfo-pdl-1">
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.DescriptionText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.description ? speciesDescription.description : getAvailableLabel() }}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.QualityControlCriteriaText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.qualityControlCriteria ? speciesDescription.qualityControlCriteria : getAvailableLabel()}}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.TechnicalCharacteristicsText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.technicalCharacteristics ? speciesDescription.technicalCharacteristics : getAvailableLabel()}}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.ExportedVarietiesText' | translate}}:</span>
              <p class="text-info">{{offer.variety.species.exportVarieties}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-bottom" *ngIf="profile?.profileType !== 'Importer'">
      <div class="section-description">
        <h2 class="title-section">{{'ExportOffer.ExportOfferDetail.SpecieDescription.Title' | translate}}</h2>
        <div class="section-description-info">
          <div class="rowInfo">
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.DescriptionText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.description ? speciesDescription.description : getAvailableLabel() }}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.QualityControlCriteriaText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.qualityControlCriteria ? speciesDescription.qualityControlCriteria : getAvailableLabel()}}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.TechnicalCharacteristicsText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.technicalCharacteristics ? speciesDescription.technicalCharacteristics : getAvailableLabel()}}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.ExportedVarietiesText' | translate}}:</span>
              <p class="text-info">{{offer.variety.species.exportVarieties}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-bottom pdb-5">
      <div class="section-description">
        <h2 class="title-section">{{'ExportOffer.ExportOfferDetail.ProductDescription' | translate}}</h2>
        <div class="section-description-info">

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.SpeciesText' | translate}}:
            </span>
            <p class="small-data-info">
              {{ offer.variety.species.name }}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.VarietyText' | translate}}:
            </span>
            <div class="flex align-items-center">
              <div class="flex align-items-center">
                <img loading="lazy" [src]="offer.variety.urlIcon | speciesImageUrl" style="width: 18px;margin-right:.5em;" alt=""/>
                <p class="small-data-info">
                  {{offer.variety.name}}
                </p>
              </div>
            </div>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.CategoryText' | translate}}:
            </span>
            <p class="small-data-info">
              <app-text-preview
                [text]="offer.category ? offer.category : getAvailableLabel()"
                [maxLength]="30">
              </app-text-preview>
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.LocationLabel' | translate}}:
            </span>
            <p class="small-data-info">
              <app-text-preview *ngIf="offer.fridgeStorage"
                [text]="offer.fridgeStorage.contactCity + ', ' + (offer.fridgeStorage.contactCountry | countryDescription)"
                [maxLength]="30">
              </app-text-preview>
              <app-text-preview *ngIf="!offer.fridgeStorage"
                [text]="offer.country?.name ? offer.country?.name : getAvailableLabel()"
                [maxLength]="30">
              </app-text-preview>
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.HarvestDateText' | translate}}:
            </span>
            <p class="small-data-info" *ngIf="offer.harvestTypeId === 1">
              {{offer.harvestDate ? (offer.harvestDate | date: 'dd/MM/yyyy') : getAvailableLabel()}}
            </p>
            <p class="small-data-info" *ngIf="offer.harvestTypeId === 2 || offer.harvestTypeId === 3 ">
              {{offer.harvestStartDate ? (offer.harvestStartDate | date: 'dd/MM/yyyy') : getAvailableLabel()}}
              -
              {{offer.harvestEndDate ? (offer.harvestEndDate | date: 'dd/MM/yyyy') : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.ShelfLife' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.shelfLife ? offer.shelfLife + ' ' + translate.instant('ExportOffer.ExportOfferDetail.DayShelflifeText') : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.CasePerPalletsText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.caseQuantityPerPallet}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.SpeciesSizeText' | translate}}:
            </span>
            <p class="small-data-info">
              <app-text-preview
                [text]="offer.speciesSize ? offer.speciesSize : getAvailableLabel()"
                [maxLength]="30">
              </app-text-preview>
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.SpeciesSizeMillimetersFieldText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.sizeMillimeters ? offer.sizeMillimeters + ' mm.' : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.NetKilosText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.netKilos ? offer.netKilos + ' Kg.' : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.GrossKilosText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.grossKilos ? offer.grossKilos + ' Kg.' : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.BoxTypeText' | translate}}:
            </span>
            <p class="small-data-info">
              <app-text-preview
                [text]="offer.boxType ? getBoxType(offer.boxType) : getAvailableLabel()"
                [maxLength]="30">
              </app-text-preview>
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'MarketplacePage.WishList.ExportOfferModal.Packaging' | translate}}:
            </span>
            <p class="small-data-info">
              {{ offer.netKilos ? getPackagingTypes(offer.packagingTypes) : getNoAvailableLabel() }}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.BasePalletsText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.basePallets ? getBasePallets(offer.basePallets) : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.ColorText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.color ? offer.color : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.MarksText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.marks ? markTrue : "No"}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.ReadyToLoadDateText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.readyToLoadDate ? (offer.readyToLoadDate | date: 'dd-MM-yyyy') : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'MarketplacePage.WishList.ExportOfferModal.qualityControlText' | translate}}:
            </span>
            <p  *ngIf="offer.qualityDocuments.length <= 0" class="small-data-info">{{'UserPages.UserExportOffers.NotIncluded' | translate}}</p>
            <div class="flex align-items-center" style="margin-top: 0px; padding: 0;" *ngIf="offer.qualityDocuments.length > 0">
              <p   class="small-data-info">{{'UserPages.UserExportOffers.Included' | translate}}</p>
              <p-button
                (onClick)="getExportOfferQualityDocument(offer.qualityDocuments)"
                pTooltip="{{'UserPages.UserExportOffers.EditExportOffer.ViewQualityDocument' | translate}}"
                [style]="{ 'margin': 0, 'padding': 0 }"
                icon="pi pi-file-pdf"
                styleClass="p-button-link p-button-lg">
              </p-button>
            </div>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.CaseSize' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.caseSize ? offer.caseSize : getAvailableLabel()}}
            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.QualityControlDateText' | translate}}:
            </span>
            <p class="small-data-info">
              {{offer.qualityControlDate ? (offer.qualityControlDate | date: 'dd-MM-yyyy') : getAvailableLabel()}}

            </p>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.OriginCountryText' | translate}}:
            </span>
            <div class="flex align-items-center">
              <div class="flex align-items-center">
                <img loading="lazy" [flag]="offer.country?.code" style="width: 18px; margin-right:10px" alt=""/>
                <p class="small-data-info">
                  {{offer.country | countryDescription}}
                </p>
              </div>
            </div>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.MarketCountry1Text' | translate}}:
            </span>
            <div class="flex align-items-center">
              <div class="flex align-items-center">
                <img loading="lazy" [flag]="offer.marketCountryFirst?.code" style="width: 18px; margin-right:10px" alt=""/>
                <p class="small-data-info">
                  {{offer.marketCountryFirst ? (offer.marketCountryFirst | countryDescription) : getAvailableLabel()}}
                </p>
              </div>
            </div>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.MarketCountry2Text' | translate}}:
            </span>
            <div class="flex align-items-center">
              <div class="flex align-items-center" *ngIf="offer.marketCountrySecond">
                <img loading="lazy" [flag]="offer.marketCountrySecond.code" style="width: 18px; margin-right:10px" alt=""/>
                <p class="small-data-info">
                  {{offer.marketCountrySecond ? (offer.marketCountrySecond | countryDescription) : getAvailableLabel()}}
                </p>
              </div>
              <div class="flex align-items-center"  *ngIf="!offer.marketCountrySecond">
                <p class="small-data-info">
                  {{'ExportOffer.ExportOfferDetail.NoAvailable' | translate}}
                </p>
              </div>
            </div>
          </div>

          <div class="container-description-info">
            <span class="span-info" >
              {{'ExportOffer.ExportOfferDetail.MarketCountry3Text' | translate}}:
            </span>
            <div class="flex align-items-center">
              <div class="flex align-items-center" *ngIf="offer.marketCountryThird">
                <img loading="lazy" [flag]="offer.marketCountryThird.code" style="width: 18px; margin-right:10px" alt=""/>
                <p class="small-data-info">
                  {{offer.marketCountryThird ? (offer.marketCountryThird | countryDescription) : getAvailableLabel()}}
                </p>
              </div>
              <div class="flex align-items-center" *ngIf="!offer.marketCountryThird">
                <p class="small-data-info">
                  {{'ExportOffer.ExportOfferDetail.NoAvailable' | translate}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    -->

  </div>

</div>
